import { HTTP } from '../../utils'

export const getJobDetail = (uuid) => {
  return HTTP().get('job/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const createJob = (job) => {
  return HTTP().put('job', job).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateJob = (job) => {
  return HTTP().put('job/' + job.uuid, job).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const saveJobActivity = (jobActivity) => {
  const url = 'job/activity'
  return HTTP().put(url, jobActivity).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const saveJobApplication = (jobApplication) => {
  const url = 'job/application'
  return HTTP().put(url, jobApplication).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateJobApplication = (application) => {
  const url = 'job//application/update/status'
  return HTTP().put(url, application).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateJobApplicationUserStatus = (applicationId, status) => {
  return HTTP().put('job/' + applicationId + '/status/' + status).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const loadJobApplication = (jobId) => {
  const url = 'job/'+jobId+'/user/application'
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const loadAllJobApplication = (jobId) => {
  const url = 'job/'+jobId+'/all/application'
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const loadAllJobActivity = (jobId) => {
  const url = 'job/'+jobId+'/all/activity'
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const loadJobApplications = () => {
  const url = 'job/user/all/application'
  return HTTP().get(url).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getSubOrganization = (uuid) => {
  return HTTP().get('suborganization/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const createSubOrganization = (subOrg) => {
  return HTTP().put('suborganization', subOrg).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateSubOrganization = (subOrg) => {
  return HTTP().put('suborganization/' + subOrg.uuid, subOrg).then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getSubOrganizationsByParent = (parentId) => {
  return HTTP().get('suborganization/' + parentId + '/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doCsvUploadForSubOrganization = (parentId, createdByUuid, fileData) => {
  if (!parentId || !fileData) {
    return
  }
  let url = '/suborganization/csvupload?parentId=' + parentId
  if (createdByUuid) {
    url += '&createdByUuid=' + createdByUuid
  }
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const doCsvUploadForJob = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/job/csvupload?createdByUuid=' + createdByUuid + '&folderId=' + folderId + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/job/api.js